import "./SerialNumberInventory.scss";

export default function SerialNumberInventory() {
  return (
    <section className="sales-layout__page serial-number-inventory">
      <h1>Seriennr Inventur</h1>
      <p>Hier wird zukünftig die Inventur anhand von Seriennummern durchgeführt.</p>
    </section>
  );
}
